import "tippy.js/dist/tippy.css";
import $ from "jquery";
import tippy from "tippy.js";
const initializeTippy = () => {
    // Initialize tooltip
    $(() => {
        tippy(".unverified-data", {
            "content": "Information needs to be verified",
            "theme": "dnbtooltip",
        });
        tippy("[data-tippy-content]", {
            "theme": "dnbtooltip",
        });
    });
};
export { initializeTippy };
